import {useEffect, useState} from 'react';
import useAlert from './Alert/useAlert';
import DateInput from './input/DateInput';
import { FileInput } from './input/FileInput';
import { IngredientSelector } from './IngredientSelector';
import { TextInput } from './input/TextInput';
import { NumberInput } from './input/NumberInput';
import { SubmitButton } from './SubmitButton';
import Title from './Title';
import LotAPI from '../services/lot.api.service';
import {CategorySelect} from "./Discount/CategorySelect";


export const CreateProductForm = ({customer}) => {
    let reloadIngredients = null;
    const defaultState = {
        name: '',
        boxes: '',
        description: '',
        category: null,
        leaflet: '',
        ingredients: [],
        expires: null,
        loading: false,
    };

    const {showSuccessAlert, showErrorAlert} = useAlert();
    const [state, setState] = useState({...defaultState});
    const changeState = partialState => setState(currentState => ({...currentState, ...partialState}));

    const handleSubmit = () => {
        changeState({loading: true})
        LotAPI
            .postLot({
                customer: customer.id,
                name: state.name,
                boxes: state.boxes,
                category: state.category,
                description: state.description,
                expires: state.expires,
                leaflet: state.leaflet,
                ingredients: state.ingredients,
            })
            .then(() => {
                showSuccessAlert('NFT successfully generated');
                changeState({...defaultState});
                reloadIngredients();
            })
            .catch(err => showErrorAlert(err.response.data.message))
            .finally(() => changeState({loading: false}))
    }

    return <>
        <Title>Fill the NFT Product attributes</Title>
        <NumberInput
            label="NFTQuantity"
            value={state.boxes}
            onChange={boxes => changeState({boxes})}
        />
        <TextInput
            label="NFTProductName"
            value={state.name}
            onChange={name => changeState({name})}
        />
        <TextInput
            label="NFTProductDescription"
            value={state.description}
            onChange={description => changeState({description})}
        />
        <IngredientSelector
            customer={customer}
            reloadIngredients={loadIngredients => reloadIngredients = loadIngredients}
            onChange={ingredients => changeState({ingredients})}
        />
        <CategorySelect
            label="Product category"
            multiply={true}
            onChange={category => changeState({category})}
        />
        <FileInput
            label="NFTLeaflet (XML file with tags for any languages available)"
            onChange={leaflet => changeState({leaflet})}
            accept=".xml"
        />
        <DateInput
            label="NFT Basic Ingredients Expiring"
            value={state.expires}
            onChange={expires => changeState({expires})}
        />
        <SubmitButton
            text="NFT GENERATION"
            loading={state.loading}
            disabled={
                !customer
                || !state.name
                || !state.boxes
                || !state.description
                || !state.category
                || !state.leaflet
                || !state.ingredients.length
                || !state.expires
            }
            handleSubmit={handleSubmit}
        />
    </>;
}
